import React, { useState } from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import ModalFrameworkForm from './ModalFrameworkForm';
import CardFramework from './viewComponents/card_framework';
import { deleteCoreFramework } from '../core_services';

/**
 * Reusable repository of visual frameworks — see core module design notes,
 * 2026-08-19. Not tied to a horizon; referenced (optionally) from any
 * CoreCycle via ModalCoreCycleForm's "Framework" select.
 */
const CardSkeleton = () => (
  <div className="bg-white p-4 rounded-xl shadow animate-pulse">
    <div className="h-4 w-1/3 rounded bg-gray-200" />
    <div className="h-3 w-2/3 rounded bg-gray-100 mt-2" />
  </div>
);

const TabCoreFrameworks = ({ frameworks, loadFrameworks, isLoading = false }) => {
  /** undefined = closed; null = create new; object = view/edit existing */
  const [frameworkModal, setFrameworkModal] = useState(undefined);

  const handleSuccess = () => {
    loadFrameworks();
  };

  const handleDelete = async (id) => {
    await deleteCoreFramework(id);
  };

  return (
    <>
      {frameworkModal !== undefined && (
        <ModalFrameworkForm
          framework={frameworkModal}
          onClose={() => setFrameworkModal(undefined)}
          onSuccess={handleSuccess}
          onDelete={handleDelete}
        />
      )}

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
          <CardSkeleton />
          <CardSkeleton />
        </div>
      ) : frameworks.length === 0 ? (
        <p className="text-gray-500 px-2">No frameworks registered yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
          {frameworks.map((framework) => (
            <CardFramework
              key={framework.id}
              framework={framework}
              onClick={() => setFrameworkModal(framework)}
            />
          ))}
        </div>
      )}

      <button
        onClick={() => setFrameworkModal(null)}
        className="fixed bottom-20 right-6 bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg"
      >
        <PlusCircleIcon className="h-8 w-8" />
      </button>
    </>
  );
};

export default TabCoreFrameworks;
